import Kichiri from "./KichiriService";
import UserService from "./UserService";

const GmailService = {
	/**
	 * Fetches the OAuth consent URL the user should be redirected (or popped up) to.
	 *
	 * @returns {Promise<{ url: string } | null>}
	 */
	async getAuthUrl() {
		try {
			let user = UserService.getUserData();
			let response = await Kichiri.gmail.gmailAuthUrl({}, {}, user.authToken);
			return response.data;
		} catch (error) {
			console.log(error);
			return null;
		}
	},

	/**
	 * Returns whether the current user has Gmail connected and which address.
	 *
	 * @returns {Promise<{ connected: boolean, gmailAddress: string | null, lastUsedAt: string | null }>}
	 */
	async getStatus() {
		try {
			let user = UserService.getUserData();
			let response = await Kichiri.gmail.gmailStatus({}, {}, user.authToken);
			return response.data;
		} catch (error) {
			console.log(error);
			return { connected: false, gmailAddress: null, lastUsedAt: null };
		}
	},

	/**
	 * Disconnects the current user's Gmail account.
	 *
	 * @returns {Promise<{ disconnected: boolean } | null>}
	 */
	async disconnect() {
		try {
			let user = UserService.getUserData();
			let response = await Kichiri.gmail.gmailDisconnect({}, {}, user.authToken);
			return response.data;
		} catch (error) {
			console.log(error);
			return null;
		}
	},

	/**
	 * Opens the Google consent screen in a centered popup and resolves with
	 * the result message posted back by the callback page.
	 *
	 * @param {Object} params
	 * @param {string} params.url
	 * @returns {Promise<{ ok: boolean, gmailAddress: string | null, message: string | null }>}
	 */
	openConsentPopup({ url }) {
		return new Promise(function (resolve) {
			let width = 520;
			let height = 640;
			let left = window.screenX + (window.outerWidth - width) / 2;
			let top = window.screenY + (window.outerHeight - height) / 2;

			let popup = window.open(url, "gmail-oauth", `width=${width},height=${height},left=${left},top=${top}`);

			let resolved = false;

			function handleMessage(event) {
				let payload = event.data;
				if (!payload || payload.source !== "gmail-oauth") return;

				resolved = true;
				window.removeEventListener("message", handleMessage);
				resolve({ ok: !!payload.ok, gmailAddress: payload.gmailAddress || null, message: payload.message || null });
			}

			window.addEventListener("message", handleMessage);

			let pollClosed = setInterval(function () {
				if (popup && popup.closed) {
					clearInterval(pollClosed);
					if (!resolved) {
						window.removeEventListener("message", handleMessage);
						resolve({ ok: false, gmailAddress: null, message: "Popup closed before completing." });
					}
				}
			}, 500);
		});
	},
};

export default GmailService;
